import DefaultLayout from '##/Default';
import List from './List';


const routes = [

    {
        path: '/notaries',
        exact: true,
        layout: DefaultLayout,
        component: List,
        auth: true,
        title: 'Manage Notaries'
    }
];


export default routes;
